/**
 * jquery.mask.js
 * @version: v1.14.16
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {
    'use strict';

    var Mask = function (el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('keydown.mask', function(e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                    el.data('mask-previus-caret-pos', p.getCaret());
                    p.maskDigitPosMapOld = p.maskDigitPosMap;
                })
                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function(oldVal) {
                var newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                      caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew])  {
                          var caretPos = caretPosNew;
                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                          caretPosNew -= maskDigitsBeforeCaret;
                          if (p.maskDigitPosMap[caretPosNew])  {
                            caretPosNew = caretPos;
                          }
                        }
                    }
                    else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret(),
                        oldVal = el.data('mask-previus-value') || '';

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                      p.setCaret(p.calculateCaretPosition(oldVal));
                    }, $.jMaskGlobals.keyStrokeCompensation);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar && m !== resetPos) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
              var maskDiff = options.reverse ? newVal.length - valLen : 0;
              p.maskDigitPosMap = {};
              for (var i = 0; i < maskDigitPosArr.length; i++) {
                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
              }
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this, oldValue = p.val(), regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            if (jMask.options.placeholder) {
                el.removeAttr('placeholder');
            }
            if (el.data('mask-maxlength')) {
                el.removeAttr('maxlength');
            }
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
           return p.getMasked(false, val);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                  el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
           options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
    notSameMaskObject = function(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
    eventSupported = function(eventName) {
        var el = document.createElement('div'), isSupported;

        eventName = 'on' + eventName;
        isSupported = (eventName in el);

        if ( !isSupported ) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        keyStrokeCompensation: 10,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));

(function($) {
    /*
    *  This function will render a Google Map onto the selected jQuery element
    */
        
    function render_map( $el ) {
        var $markers = $el.find('.marker');
        var args = {
            zoom		: 16,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };        	
        var map = new google.maps.Map( $el[0], args);
    
        map.markers = [];
        $markers.each(function(){
            add_marker( $(this), map );
        });
    
        center_map( map );
    }
        
    /*
    *  This function will add a marker to the selected Google Map
    */
        
    function add_marker( $marker, map ) {
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        var marker = new google.maps.Marker({
            position	: latlng,
            map			: map
        });
    
        map.markers.push( marker );
    
        if( $marker.html() ) { 
            var infowindow = new google.maps.InfoWindow({
                content		: $marker.html()
            });
    
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }
    
    /*
    *  This function will center the map, showing all markers attached to this map
    */
    
    function center_map( map ) {
        var bounds = new google.maps.LatLngBounds();
    
        $.each( map.markers, function( i, marker ){
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
        });
    
        if( map.markers.length == 1 ) {
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
        } else {
            map.fitBounds( bounds );
        }
    }
    
    /*
    *  This function will render each map when the document is ready (page has loaded)
    */
    
    $(document).ready(function(){
        $('.acf-map').each(function(){
            render_map( $(this) );
        });
    });
    /**
     * Menu script
     */
    class MM_Menu {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.win = $(window);
            this.menuWrapper = $('.site-header');
            this.menuIcon = this.menuWrapper.find('.menu-toggle');
            this.menu = this.menuWrapper.find('.menu-block');
            this.menuItemSubmenu = this.menu.find('.menu-item.menu-item-has-children');
            this.mobileViewport = window.matchMedia("screen and (max-width: 1040px)");
        }
    
        initEvents() {
            this.menuItemSubmenu.append( "<span class='arrow'></span>" );
    
            $(window).on('scroll', () => {
                let positionY = this.win.scrollTop();
    
                if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
                    this.menuWrapper.addClass('is-fixed');
                    return;
                }
    
                if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
                    this.menuWrapper.removeClass('is-fixed');
                }
            });
    
            if (this.mobileViewport.matches) {
                this.openMobileMenu();
            }
    
            this.mobileViewport.addListener((mq) => {
                if (mq.matches) {
                    this.openMobileMenu();
                } else {
                    this.menu.removeClass('is-showing');
                    this.menuIcon.removeClass('is-active');
                    this.menuIcon.attr('aria-expanded', 'false');
                    $('.menu-item').removeClass('is-active');
                    $(document.body).removeClass('no-scroll');
    
                    setTimeout(() => {
                        this.menu.removeClass('is-active');
                    }, 150);
                }
            });
    
            this.initDynamicBgHeight();
        }
    
        initDynamicBgHeight () {
            let firstLevelItemsWithChildren = $('#main-menu').children('li.menu-item-has-children');
            
            for (let i = 0; i < firstLevelItemsWithChildren.length; i++) {
                this.recursiveChildrenCounter(firstLevelItemsWithChildren.eq(i), 0);
                let submenuBg = firstLevelItemsWithChildren.eq(i).children('.sub-menu');
                let allSubElementsWithChildrenCount = firstLevelItemsWithChildren.eq(i).find('li[data-children-count]');
                let currentHeight = 0;
                let currentLevel = 0;
    
                firstLevelItemsWithChildren.eq(i).on('mouseenter', function () {
                    let newHeight = parseInt($(this).attr('data-children-count'), 10);
                    let newLevel = parseInt($(this).attr('data-children-level'), 10);
                    
                    if (newHeight > currentHeight && newLevel >= currentLevel) {
                        currentHeight = newHeight;
                        submenuBg.attr('data-bg-height', newHeight);
                    } else if (newHeight < currentHeight && newLevel < currentLevel) {
                        currentHeight = newHeight;
                        submenuBg.attr('data-bg-height', newHeight);
                    }
    
                    currentLevel = newLevel;
                });
    
                for (let j = 0; j < allSubElementsWithChildrenCount.length; j++) {
                    allSubElementsWithChildrenCount.on('mouseenter', function () {
                        let newHeight = parseInt($(this).attr('data-children-count'), 10);
                        let newLevel = parseInt($(this).attr('data-children-level'), 10);
                        
                        if (newHeight > currentHeight && newLevel >= currentLevel) {
                            currentHeight = newHeight;
                            submenuBg.attr('data-bg-height', newHeight);
                        } else if (newHeight < currentHeight && newLevel <= currentLevel) {
                            currentHeight = newHeight;
                            submenuBg.attr('data-bg-height', newHeight);
                        }
    
                        currentLevel = newLevel;
                    });
                }
            }
        }
    
        recursiveChildrenCounter (parent, level, parentHeight = 0) {
            let children = parent.children('.sub-menu').eq(0).children('li');
            let hasPromotedProducts = parent.children('.menu-promoted-products');
            parent.attr('data-children-level', level);
    
            if (hasPromotedProducts.length) {
                parent.attr('data-children-count', 5);
            } else {
                parent.attr('data-children-count', children.length);
    
                if (children.length === 0) {
                    parent.attr('data-children-count', parentHeight);
                }
            }
    
            for (let i = 0; i < children.length; i++) {
                this.recursiveChildrenCounter(children.eq(i), level + 1, children.length);
            }
        }
    
        openMobileMenu () {
            if (this.menuWrapper.attr('data-is-initialized')) {
                return;
            }
    
            this.menuWrapper.attr('data-is-initialized', 'true');
    
            setTimeout(() => {
                this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
    
                this.menuSubmenuToggle.each(function(i, item) {
                    $(item).on('click', function() {
                        $(item).parent().toggleClass('is-active');
                    });
                });
            }, 0);
    
            if (this.menuIcon.length) {
                this.menuIcon.on('click', e => {
                    e.preventDefault();
                    let menuIconValue = this.menuIcon.attr('aria-expanded');
                    this.menu.toggleClass('is-active');
                    this.menuIcon.toggleClass('is-active');
                    this.menuIcon.attr('aria-expanded', 'true');
                    $(document.body).toggleClass('no-scroll');
    
                    if ( menuIconValue === 'true') {
                        this.menuIcon.attr('aria-expanded', 'false');
                    }
    
                    setTimeout(() => {
                        this.menu.toggleClass('is-showing');
                    }, 150);
                });
            }
        }
    }
    
    /**
     * UI elements
     */
    class MM_UI {
        constructor() {
            this.initFocusForms();
            this.initAutocompleteSearchOff();
            this.initTextAccordion();
            this.initAgeementsAccordion();
            this.initBackLinksInCategories();
            this.initCustomInputNumber();
            this.initAddPlaceholders();
            this.initWrapCheckbox();
            this.initShowFVInput();
            this.initOpenSidebar();
            this.initHideDeliveryIcon();
            this.iniExpandDescription();
            this.initClosePromoPopup();
            this.initOpenTooltip();
    
            $(document).ready(() => {
                this.initSmoothScroll();
            });
        }
    
        initFocusForms () {
            var inputs = document.querySelectorAll('.has-focus');
    
            for (var i = 0; i < inputs.length; i++) {
                var input = inputs[i];
    
                input.addEventListener('focus', function() {
                    this.classList.add('is-active');
                });
    
                input.addEventListener('blur', function() {
                    if (this.value === '') {
                        this.classList.remove('is-active');
                    }
                });
            }
        }
    
        initSmoothScroll () {
            $('a[href*="#"]').not('[href^="#tab-"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - 60
                        }, 1000);
                    }
                }
            });
        }
    
        initAutocompleteSearchOff() {
            let inputSearch = $('.search-field');
    
            if (inputSearch.length) {
                inputSearch.attr('autocomplete', 'off');
            }
        }
    
        initTextAccordion () {
            $(".composition-block").each(function(i, item) {
                $(item).find('.text-wrapper').css('height', 0);
                $(item).removeClass('not-initialized');
    
                $(item).on("click", function () {
                    var item = $(this);
                    var contentWrapper = item.find('.text-wrapper');
                    var contentText = item.find('.text-wrapper p');
    
                    item.toggleClass('active');
                    var newHeight = contentText.outerHeight();
    
                    if (item.hasClass('active')) {
                        contentWrapper.css('height', 0);
    
                        setTimeout(function() {
                            contentWrapper.css('height', newHeight + 'px');
                        }, 0);
    
                        setTimeout(function() {
                            contentWrapper.css('height', 'auto');
                        }, 500);
                    } else {
                        contentWrapper.css('height', newHeight + 'px');
    
                        setTimeout(function() {
                            contentWrapper.css('height', 0);
                        }, 0);
                    }
                });
            });
        }
    
        initAgeementsAccordion () {
            $('.more-info-wrapper').each(function(i, item) {
                $(item).find('.more-info').css('height', 0);
                $(item).removeClass('not-initialized');
    
                $(item).on("click", function (e) {
                    e.preventDefault();
                    var item = $(this);
                    var contentWrapper = item.find('.more-info');
                    var contentText = item.find('.more-info p');
                    item.toggleClass('active');
                    var newHeight = contentText.outerHeight();
                    if (item.hasClass('active')) {
                        contentWrapper.css('height', 0);
                        contentWrapper.css('opacity', 0);
    
                        setTimeout(function() {
                            contentWrapper.css('height', newHeight + 'px');
                            contentWrapper.css('opacity', 1);
                        }, 0);
    
                        setTimeout(function() {
                            contentWrapper.css('height', 'auto');
                            contentWrapper.css('opacity', 1);
                        }, 500);
                    } else {
                        contentWrapper.css('height', newHeight + 'px');
                        contentWrapper.css('opacity', 1);
    
                        setTimeout(function() {
                            contentWrapper.css('height', 0);
                            contentWrapper.css('opacity', 0);
                        }, 0);
                    }
                });
            });
        }
    
        initBackLinksInCategories () {
            let basicUrl = $(document.body).attr('data-shop-url');
            let widgetWrapper = $('.shop-sidebar .product-categories');
    
            if (widgetWrapper.length) {
                let currentCatLink = widgetWrapper.find('.current-cat');
    
                if (currentCatLink.length && currentCatLink.find('a').length) {
                    let goBackLink = $('<a class="go-back-link">&times;</a>');
                    goBackLink.attr('href', basicUrl);
                    currentCatLink.find('a').eq(0).after(goBackLink);
                }
            }
        }
    
        initCustomInputNumber () {
            let quantityWrapper = $('.woocommerce');
            let quantity = quantityWrapper.find('.quantity');
    
            quantity.append($('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>'));
    
            $('.quantity').each(function() {
                let spinner = $(this),
                input = spinner.find('input[type="number"]'),
                btnUp = spinner.find('.quantity-up'),
                btnDown = spinner.find('.quantity-down'),
                min = input.attr('min'),
                max = input.attr('max');
        
                btnUp.click(function() {
                    let oldValue = parseFloat(input.val());
                    let newVal = oldValue + 1;
    
                    if (max > 0 && oldValue >= max) {
                        newVal = oldValue;
                    } 
    
                    input.val(newVal);
                    input.trigger("change");
                });
        
                btnDown.click(function() {
                    let oldValue = parseFloat(input.val());
                    let newVal = oldValue - 1;
    
                    if (oldValue <= min) {
                        newVal = oldValue;
                    }
    
                    input.val(newVal);
                    input.trigger("change");
                });
            });
    
            $( document.body ).on( 'updated_cart_totals', function(){
                let quantityWrapper = $('.woocommerce');
                let quantity = quantityWrapper.find('.quantity');
                quantity.append($('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>'));
    
                $('.quantity').each(function() {
                    let spinner = $(this),
                    input = spinner.find('input[type="number"]'),
                    btnUp = spinner.find('.quantity-up'),
                    btnDown = spinner.find('.quantity-down'),
                    min = input.attr('min'),
                    max = input.attr('max');
            
                    btnUp.click(function() {
                        let oldValue = parseFloat(input.val());
                        let newVal = oldValue + 1;
        
                        if (max > 0 && oldValue >= max) {
                            newVal = oldValue;
                        } 
        
                        input.val(newVal);
                        input.trigger("change");
                    });
            
                    btnDown.click(function() {
                        let oldValue = parseFloat(input.val());
                        let newVal = oldValue - 1;
        
                        if (oldValue <= min) {
                            newVal = oldValue;
                        }
        
                        input.val(newVal);
                        input.trigger("change");
                    });
                });
            });
        }
    
        initAddPlaceholders () {
            let inputs = $('.input-text');
            let inputName = $('input[name="account_first_name"]');
            let inputLastname = $('input[name="account_last_name"]');
            let inputPasCurrent = $('input[name="password_current"]');
            let inputPasNew = $('input[name="password_1"]');
            let inputPasNew2 = $('input[name="password_2"]');
            let loginWrapper = $('#customer_login .login');
            let regWrapper = $('#customer_login .register');
            let loginUser = loginWrapper.find('input[name="username"]');
            let loginPass = loginWrapper.find('input[name="password"]');
            let regEmail = regWrapper.find('input[name="email"]');
            let regPass = regWrapper.find('input[name="password"]');
            let wooCheckout = $('body.woocommerce-checkout');
            let wooCheckoutLogin = wooCheckout.find('.woocommerce-form-login');
            let wooCheckoutLoginUser = wooCheckoutLogin.find('input[name="username"]');
            let wooCheckoutLoginPass = wooCheckoutLogin.find('input[name="password"]');
            let wooCheckoutCompany = wooCheckout.find('input[name="billing_company"]');
            let wooCheckoutShipName = wooCheckout.find('input[name="shipping_first_name"]');
            let wooCheckoutShipLastname = wooCheckout.find('input[name="shipping_last_name"]');
            let wooCheckoutShipCompany = wooCheckout.find('input[name="shipping_company"]');
    
            for (let i = 0; i < inputs.length; i++) {
                var input = inputs.eq(i);
                var inputLabel = input.parent().parent().find('label').text();
                var inputPlaceholder = input.attr('placeholder');
    
                if( inputPlaceholder === undefined || inputPlaceholder === '') {
                    input.attr('placeholder', inputLabel);
                }
            }
    
            inputPasCurrent.attr('placeholder', 'Aktualne hasło (pozostaw puste, aby nie zmieniać)');
            inputPasNew.attr('placeholder', 'Nowe hasło');
            inputPasNew2.attr('placeholder', 'Potwierdź hasło');
            inputName.attr('placeholder', 'Imię*');
            inputLastname.attr('placeholder', 'Nazwisko*');
            loginUser.attr('placeholder', 'Adres e-mail');
            loginPass.attr('placeholder', 'Hasło');
            regEmail.attr('placeholder', 'Adres e-mail');
            regPass.attr('placeholder', 'Hasło');
            wooCheckoutLoginUser.attr('placeholder', 'Użytkownik lub e-mail');
            wooCheckoutLoginPass.attr('placeholder', 'Hasło');
            wooCheckoutCompany.attr('placeholder', 'Nazwa firmy');
            wooCheckoutShipName.attr('placeholder', 'Imię');
            wooCheckoutShipLastname.attr('placeholder', 'Nazwisko');
            wooCheckoutShipCompany.attr('placeholder', 'Nazwa firmy');
        }
    
        initWrapCheckbox () {
            var checkboxWrapper = $('.checkout');
            var checkboxInput = checkboxWrapper.find('input[type="checkbox"]');
    
            if (checkboxInput.length) {
                checkboxInput.parent().addClass('checkbox-wrapper');
            }
        }
    
        initShowFVInput() {
            let fvCheckboxWrapper = $('.fv-checkbox-wrapper');
            let fvCheckboxWrapperLabel = fvCheckboxWrapper.children('label');
            let fvCheckboxWrapperNIP = fvCheckboxWrapper.find('.nip-input');
            let input = fvCheckboxWrapper.find('.input-checkbox');
            input.css('pointer-events', 'none');
    
            fvCheckboxWrapperLabel.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                input.prop('checked', !input.prop('checked'));
                fvCheckboxWrapperNIP.toggleClass('is-active');
    
                let optionValue = input.prop('checked') ? 'Chcę otrzymać fakturę VAT' : 'Bez faktury VAT';
    
                dataLayer.push({     
                    'event': 'checkoutOption', 
                    'ecommerce': { 
                        'checkout_option': { 
                            'actionField': {
                                'step': 2, 
                                'option': optionValue
                            } 
                        }
                    } 
                }); 
            });
        }
    
        initOpenSidebar () {
            var openFilters = $('.open-filters');
            var sidebar = $('.shop-sidebar')
    
            if (openFilters.length) {
                openFilters.on('click', e => {
                    e.preventDefault();
                    sidebar.toggleClass('is-active');
                });
            }
        }
    
        initHideDeliveryIcon () {
            if (!$('body').hasClass('single-product')) {
                return;
            }
    
            let variationRadios = $('.woovr-variation-radio');
            let benefits = $('.footer-benefits-block.short .benefits-list .benefit')
    
            if (variationRadios.length && benefits.length) {
                let imageToToggle = benefits.eq(0);
                let checkedInput = $('.woovr-variation-radio input:checked');
    
                if (checkedInput.parents('.woovr-variation-radio').attr('data-purchasable') === 'no') {
                    imageToToggle.addClass('is-hidden');
                }
                
                variationRadios.each((i, radio) => {
                    $(radio).on('click', () => {
                        if ($(radio).attr('data-purchasable') === 'no') {
                            imageToToggle.addClass('is-hidden');
                        } else {
                            imageToToggle.removeClass('is-hidden');
                        }
                    });
                });
            }
        }
    
        iniExpandDescription() {
            let readMoreBtn = $('.archive-description-read-more');
            let longDescription = $('#custom-archive-description-long');
    
            if (readMoreBtn.length) {
                readMoreBtn.on('click', function () {
                    longDescription.toggleClass('hide-element');
                    longDescription.toggleClass('open-element');
                });   
            }
        }
    
        initClosePromoPopup () {
            let popups = $('.ss-promo-offer-popup');
      
            for (let i = 0; i < popups.length; i++) {
                let closeBtn = popups.eq(i).find('.close');
                let popup = popups.eq(i);
                let popupInner = popups.eq(i).find('.popup-inner');
      
                $( document.body ).on('click', () => {
                    popup.addClass('is-hidden');
                });
        
                closeBtn.on('click', (e) => {
                    e.preventDefault();
                    popup.addClass('is-hidden');
                });
        
                popupInner.on('click', (e) => {
                    e.stopPropagation();
                });
            }
        }
    
        initOpenTooltip () {
            let tooltipsBlock = $('.has-tooltip');
          
            if (!tooltipsBlock.length) {
              return
            }
        
            for (let i = 0; i < tooltipsBlock.length; i++) {
                tooltipsBlock.eq(i).on('click', e => {
                    e.preventDefault();
                    console.log(e.target);
                    let tooltipIsActive = $(e.target).hasClass('is-active');
                    tooltipsBlock.removeClass('is-active');
                    
                    if (!tooltipIsActive) {
                        $(e.target).addClass('is-active');
                    }
                });
            }
        }
    }
    /**
     * Header Slider script
     */
    class MM_HeaderSlider {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.sliderWrapper = $('.slideshow-block');
            this.nextBtn = this.sliderWrapper.find('.next');
            this.list = this.sliderWrapper.find('.slideshow-list');
            this.items = this.list.find('.slideshow-item');
            this.dots = this.sliderWrapper.find('.dot');
        }
    
        initEvents() {
            setTimeout(() => {
                this.showNextSlide();
            }, 5500);
    
            if (this.sliderWrapper.length) {
                this.currentItem = 0;
                this.animationInProgress = false;
    
                this.nextBtn.on('click', e => {
                    e.preventDefault();
    
                    if (this.animationInProgress) {
                        return;
                    }
    
                    this.currentItem++;
                    this.animationInProgress = true;
    
                    if (this.currentItem >= this.items.length) {
                        this.currentItem = 0;
                    }
                    
                    this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
                    setTimeout(() => {
                        this.animationInProgress = false;
                    }, 550);
                });
    
                for (let i = 0; i < this.dots.length; i++) {
                    this.dots.eq(i).on('click', e => {
                        e.preventDefault();
    
                        if (this.animationInProgress) {
                            return;
                        }
    
                        this.currentItem = i;
                        this.animationInProgress = true;
                        this.dots.removeClass('is-active');
                        this.dots.eq(this.currentItem).addClass('is-active');
                        this.list.css('margin-left', (-100 * this.currentItem) + "%");
                        
                        setTimeout(() => {
                            this.animationInProgress = false;
                        }, 550);
                    });
                }
            }
        }
    
        showNextSlide () {
            this.nextBtn.trigger('click');
    
            setTimeout(() => {
                this.showNextSlide();
            }, 5500);
        }
    }
    /**
     * Product listing change view script
     */
    class MM_productListing {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.changeViewWrapper = $('.change-view');
            this.listView = this.changeViewWrapper.parent().find('.products');
            this.blockIcon = this.changeViewWrapper.find('.block');
            this.listIcon = this.changeViewWrapper.find('.list');
        }
    
        initEvents() {
            if (this.changeViewWrapper.length) {
                this.listIcon.on('click', e => {
                    e.preventDefault();
                    this.listIcon.addClass('is-active');
                    this.blockIcon.removeClass('is-active');
                    this.listView.addClass('use-list-view').removeClass('use-block-view');
                    window.localStorage.setItem('list-view', 'list');
                });
    
                this.blockIcon.on('click', e => {
                    e.preventDefault();
                    this.blockIcon.addClass('is-active');
                    this.listIcon.removeClass('is-active');
                    this.listView.addClass('use-block-view').removeClass('use-list-view');
                    window.localStorage.setItem('list-view', 'block');
                });
    
                if (window.localStorage.getItem('list-view')) {
                    if (window.localStorage.getItem('list-view') === 'block') {
                        this.changeViewWrapper.find('a').removeClass('is-active');
                        this.blockIcon.addClass('is-active');
                        this.listView.addClass('use-block-view').removeClass('use-list-view');
                    }
                
                    if (window.localStorage.getItem('list-view') === 'list') {
                        this.changeViewWrapper.find('a').removeClass('is-active');
                        this.listIcon.addClass('is-active');
                        this.listView.addClass('use-list-view').removeClass('use-block-view');
                    }
                } else {
                    this.changeViewWrapper.find('a').removeClass('is-active');
                    this.blockIcon.addClass('is-active');
                    this.listView.addClass('use-block-view').removeClass('use-list-view');
                }         
            }
    
            $(document).ajaxComplete((event, xhr, settings) => {
                this.changeViewWrapper = $('.change-view');
    
                if (!this.changeViewWrapper.length || !settings || !settings.url || settings.url.indexOf('/kategoria-produktu/') === -1) {
                    return;
                }
    
                this.listView = this.changeViewWrapper.parent().find('.products');
                this.blockIcon = this.changeViewWrapper.find('.block');
                this.listIcon = this.changeViewWrapper.find('.list');
    
                if (window.localStorage.getItem('list-view')) {
                    if (window.localStorage.getItem('list-view') === 'block') {
                        this.changeViewWrapper.find('a').removeClass('is-active');
                        this.blockIcon.addClass('is-active');
                        this.listView.addClass('use-block-view').removeClass('use-list-view');
                    }
                
                    if (window.localStorage.getItem('list-view') === 'list') {
                        this.changeViewWrapper.find('a').removeClass('is-active');
                        this.listIcon.addClass('is-active');
                        this.listView.addClass('use-list-view').removeClass('use-block-view');
                    }
                } else {
                    this.changeViewWrapper.find('a').removeClass('is-active');
                    this.blockIcon.addClass('is-active');
                    this.listView.addClass('use-block-view').removeClass('use-list-view');
                } 
            });
        }
    }
    
    /**
     * Shop checkout script - display and hiding steps
     */
    class MM_shopCheckout {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.checkoutPage = $('body.woocommerce-checkout');
            
            if (this.checkoutPage.length) {
                this.checkoutWrapper = this.checkoutPage.find('.woocommerce');
                this.checkoutForm = this.checkoutWrapper.find('.woocommerce-checkout');
                this.fastShoppingBtn = this.checkoutWrapper.find('.fast-shopping');
                this.checkoutGridFirstCol = this.checkoutForm.find('#customer_details');
                this.checkoutGridSecondCol = this.checkoutForm.find('.woocommerce-checkout-review-order');
                this.nexBtnFirstCol = this.checkoutGridFirstCol.find('.continue-btn');
                this.backBtnToStep1 = this.checkoutForm.find('.back-to-step-1');
                this.backBtnToStep2 = this.checkoutForm.find('.back-to-step-2');
                this.nexBtnSecondCol = this.checkoutForm.find('.next-btn');
    
                this.formFieldWrapper = this.checkoutForm.find('.woocommerce-billing-fields__field-wrapper');
                this.postCode = this.formFieldWrapper.find('#billing_postcode');
                this.phone = this.formFieldWrapper.find('#billing_phone');
    
                this.shippingMethod = $('#shipping_method');
                this.paymentMethods = $('.payment_methods');
                this.courierOnDelivery = this.shippingMethod.find('input[value="flexible_shipping_7_4"]');
                this.inpostOnDelivery = this.shippingMethod.find('input[value="flexible_shipping_12_6"]');
                this.cashOnDelivery = this.paymentMethods.find('#payment_method_cod');
                this.payUInput = this.paymentMethods.find('#payment_method_payustandard');
            }
        }
    
        initEvents() {
            if (!this.checkoutPage.length) {
                return;
            }
    
            this.initGTM();
            this.postCode.mask('00-000');
            this.phone.mask('000000000000000');
    
            this.fastShoppingBtn.on('click', e => {
                e.preventDefault();
                this.checkoutWrapper.addClass('checkout-step-1');
                this.checkoutForm.css('display', 'block');
                this.checkoutForm.addClass('is-active');
                this.checkoutGridFirstCol.addClass('is-active');
            });
    
            this.nexBtnSecondCol.on('click', e => {
                e.preventDefault();
                this.checkoutGridSecondCol.removeClass('is-step-2');
                this.checkoutGridSecondCol.addClass('is-step-3');
    
                let wrapper = $('#payment');
                let hook = wrapper.find('.summary-table');
                let oldData = wrapper.find('.summary-data');
                
                if (oldData.length) {
                    oldData.remove();
                }
    
                let output = this.generateSummary();
                output.insertBefore(hook);
            });
    
            this.backBtnToStep1.on('click', e => {
                e.preventDefault();
                this.checkoutGridFirstCol.removeClass('is-hidden');
                this.checkoutGridSecondCol.removeClass('is-step-2');
            });
    
            if(this.courierOnDelivery.attr('checked') === 'checked') {
                console.log('courierDelivery checked');
                $('input[name="payment_method"]').attr('checked', '');
                this.cashOnDelivery.attr('checked', 'checked');
                this.payUInput.addClass('disabled');
            } else {
                this.payUInput.removeClass('disabled');
            }
            
            this.inpostOnDelivery.on('input', () => {
                console.log('inpostDelivery checked');
                this.payUInput.toggleClass('disabled');
            });
    
            this.formName = this.checkoutForm.find('#billing_first_name');
            this.formLastName = this.checkoutForm.find('#billing_last_name');
            this.formAddress = this.checkoutForm.find('#billing_address_1');
            this.formPostCode = this.checkoutForm.find('#billing_postcode');
            this.formCity = this.checkoutForm.find('#billing_city');
            this.formEmail = this.checkoutForm.find('#billing_email');
            this.phoneNumber = this.checkoutForm.find('#billing_phone');
    
            this.nexBtnFirstCol.on('click', e => {
                e.preventDefault();
                let valid = true;
    
                $.each([this.formName, this.formLastName, this.formAddress, this.formPostCode, this.formCity, this.phoneNumber], function(i, formItem) {
                    if (formItem.val().trim() === '') {
                        formItem.parent().addClass('is-invalid');
                        formItem.one('keyup', function () {
                            return formItem.parent().removeClass('is-invalid');
                        });
                        valid = false;
                    }
                });
    
                if (this.formEmail.val().trim() === '' || this.formEmail.val().indexOf('@') === -1) {
                    this.formEmail.parent().addClass('is-invalid');
                    this.formEmail.one('keyup', () => this.formEmail.parent().removeClass('is-invalid'));
                    valid = false;
                }
    
                if (valid) {
                    this.checkoutGridFirstCol.addClass('is-hidden');
                    this.checkoutGridSecondCol.addClass('is-step-2');
                }
            });
    
            this.nexBtnFirstCol.one('click', () => {
                this.backBtnToStep2 = this.checkoutForm.find('.woocommerce-checkout-payment .back-to-step-2');
                this.backBtnToStep2.on('click', e => {
                    e.preventDefault();
                    this.checkoutGridSecondCol.removeClass('is-step-3');
                    this.checkoutGridSecondCol.addClass('is-step-2');
                });
                this.gtmSendStep2Data();
            });
        }
    
        generateSummary () {
            let shippingDeliveryCheckbox = $('#ship-to-different-address-checkbox');
            let output = $('<div class="summary-data"></div>');
            let outputCol1 = $('<div class="summary-data-col summary-data-col1"><h4 class="summary-data-title">Dane zamawiającego</h4><div class="summary-data-content"></div></div>');
            let outputCol3 = $('<div class="summary-data-col summary-data-col3"><h4 class="summary-data-title-payment">Metoda płatności</h4><div class="summary-data-content-payment"></div><h4 class="summary-data-title-shipping">Metoda wysyłki</h4><div class="summary-data-content-shipping"></div></div>');
            let billingName = $('input[name="billing_first_name"]').val();
            let billingLastName = $('input[name="billing_last_name"]').val();
            let billingStreet1 = $('input[name="billing_address_1"]').val();
            let billingStreet2 = $('input[name="billing_address_2"]').val();
            let billingPostCode = $('input[name="billing_postcode"]').val();
            let billingCity = $('input[name="billing_city"]').val();
    
            let shippingName = $('input[name="shipping_first_name"]').val();
            let shippingLastName = $('input[name="shipping_last_name"]').val();
            let shippingStreet1 = $('input[name="shipping_address_1"]').val();
            let shippingStreet2 = $('input[name="shipping_address_2"]').val();
            let shippingPostCode = $('input[name="shipping_postcode"]').val();
            let shippingCity = $('input[name="shipping_city"]').val();
    
            outputCol1.find('.summary-data-content').text(billingName + ' ' + billingLastName + ', ul.' + billingStreet1 + ' ' + billingStreet2 + ', ' + billingPostCode + ' ' + billingCity);
    
            let selectedDeliveryMethod = $('input[name="shipping_method[0]"]:checked').val();
            let deliveryMethod = $('#shipping_method label').filter((i, label) => $(label).attr('for') === 'shipping_method_0_' + selectedDeliveryMethod);
    
            let selectedPaymentMethod = $('input[name="payment_method"]:checked').val();
            let paymentMethod = $('.wc_payment_methods label').filter((i, label) => $(label).attr('for') === 'payment_method_' + selectedPaymentMethod);
    
            if (deliveryMethod.length) {
                let currentDeliveryMethod = deliveryMethod.eq(0).text();
    
                outputCol3.find('.summary-data-content-shipping').text(currentDeliveryMethod);
            }
    
            if (paymentMethod.length) {
                let currentPaymentMethod = paymentMethod.eq(0).text();
    
                outputCol3.find('.summary-data-content-payment').text(currentPaymentMethod);
            }
    
            if(shippingDeliveryCheckbox.attr('checked') === 'checked') {
                let outputCol2 = $('<div class="summary-data-col summary-data-col2"><h4 class="summary-data-title">Dane wysyłki</h4><div class="summary-data-content"></div></div>');
                outputCol2.find('.summary-data-content').text(shippingName + ' ' + shippingLastName + ', ul.' + shippingStreet1 + ' ' + shippingStreet2 + ', ' + shippingPostCode + ' ' + shippingCity);
                output.html(outputCol1[0].outerHTML + outputCol2[0].outerHTML + outputCol3[0].outerHTML);
            } else {
                output.html(outputCol1[0].outerHTML + outputCol3[0].outerHTML);
            }
    
            return output;
        }
    
        initGTM () {
            let differentAddressCheckbox = document.querySelector('#ship-to-different-address-checkbox');
    
            if (differentAddressCheckbox) {
                differentAddressCheckbox.addEventListener('change', function () {
                    let optionValue = differentAddressCheckbox.checked ? 'Inny adres' : 'Ten sam adres';
    
                    dataLayer.push({    
                        'event': 'checkoutOption', 
                        'ecommerce': { 
                            'checkout_option': { 
                                'actionField': {
                                    'step': 2, 
                                    'option': optionValue
                                } 
                            } 
                        } 
                    }); 
                }, false);
            }
    
            $('.woocommerce-checkout .woocommerce-checkout-review-order').on('click', (e) => {            
                if (e.target.tagName === 'INPUT' && e.target.classList.contains('shipping_method')) {
                    if (!e.clientX) {
                        return;
                    }
    
                    dataLayer.push({    
                        'event': 'checkoutOption', 
                        'ecommerce': { 
                            'checkout_option': { 
                                'actionField': {
                                    'step': 3, 
                                    'option': $(e.target).next('label').text().trim()
                                } 
                            } 
                        }
                    }); 
                    return;
                }
    
                if (e.target.tagName === 'INPUT' && e.target.getAttribute('name') === 'payment_method') {
                    if (!e.clientX) {
                        return;
                    }
    
                    dataLayer.push({    
                        'event': 'checkoutOption', 
                        'ecommerce': { 
                            'checkout_option': { 
                                'actionField': {
                                    'step': 3, 
                                    'option': $(e.target).next('label').text().trim()
                                } 
                            } 
                        }
                    }); 
                    return;
                }
    
                if (e.target.tagName === 'A' && e.target.classList.contains('next-btn')) {
                    this.gtmSendStep3Data();
                }
            });
        }
    
        gtmSendStep2Data () {
            dataLayer.push({ 
                'pageType': 'checkout', 
                'languageVersion': 'PL', 
                'ecommerce': { 
                    'currencyCode': 'PLN', 
                    'checkout': { 
                        'actionField': { 
                            'step': 3, 
                            'option': 'dostawa', 
                            'action': 'checkout' 
                        },
                        'products': window.mm_items_in_cart.slice()
                    }
                }
            });
        }
    
        gtmSendStep3Data () {
            dataLayer.push({ 
                'pageType': 'checkout', 
                'languageVersion': 'PL', 
                'delivery': jQuery('input.shipping_method:checked').next('label').text().trim(),
                'paymentMethod': jQuery('input[name="payment_method"]:checked').next('label').text().trim(), 
                'ecommerce': { 
                    'currencyCode': 'PLN', 
                    'checkout': { 
                        'actionField': { 
                            'step': 4, 
                            'option': 'podsumowanie', 
                            'action': 'checkout' 
                        },
                        'products': window.mm_items_in_cart.slice()
                    }
                }
            });
        }
    }
    
    /**
     * Other events for GTM
     */
    class MM_GTMEvents {
        constructor() {
            this.goToCheckout();
            this.addToCartFromList();
            this.addToCartFromProduct();
            this.productLinks();
            this.variableProductLinks();
            this.removeFromCart();
            this.updatedCartEvents();
        }
    
        goToCheckout () {
            if (!$('.wc-proceed-to-checkout').length) {
                return;
            }
    
            $('.woocommerce').on('click', (e) => {
                if (e.target.tagName === 'A' && e.target.classList.contains('checkout-button')) {
                    e.preventDefault();
    
                    dataLayer.push({     
                        'event': 'checkoutOption', 
                        'ecommerce': { 
                            'checkout_option': { 
                                'actionField': {
                                    'step': 2, 
                                    'option': 'Dane klienta'
                                } 
                            } 
                        },
                        'eventCallback': function () {
                            document.location = $(e.target).attr('href');
                        }
                    });
                }
            });
        }
    
        addToCartFromList () {
            let self = this;
    
            if (!$('a.product_type_simple.add_to_cart_button').length) {
                return;
            }
    
            $('a.product_type_simple.add_to_cart_button:not(.yith-variable-product-button)').each((i, btn) => {
                $(btn).on('click', function () {
                    let productCategory = '';
                    let categoryContent = $(this).parent().find('.product-category');
    
                    if (categoryContent.length) {
                        productCategory = categoryContent.eq(0).text();
                    }
    
                    let productPrice = '';
                    let priceContent = $(this).parent().find('.woocommerce-Price-amount');
                    
                    if (priceContent.length) {
                        productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                    }
    
                    let productName = '';
                    let nameContent = $(this).parent().find('.woocommerce-loop-product__title');
    
                    if (nameContent.length) {
                        productName = nameContent.text();
                    }
    
                    let productID = $(this).attr('data-product_sku');
                    let productDataToUse = { 	 
                        'name': productName,
                        'id': $(this).attr('data-product_sku'),
                        'price': productPrice,
                        'category': productCategory,
                        'quantity': parseInt($(this).attr('data-quantity'), 10)
                    };
    
                    if (window.mm_visible_products_list) {
                        let productData = window.mm_visible_products_list.filter(prod => prod.id === productID);
    
                        if (productData.length) {
                            productDataToUse = productData[0];
                            productDataToUse.quantity = parseInt($(this).attr('data-quantity'), 10);
                        }
                    }
    
                    dataLayer.push({ 
                        'event': 'addToCart', 
                        'pageType': self.getPageType(),
                        'languageVersion': 'PL', 
                        'ecommerce': { 
                            'currencyCode': 'PLN',
                            'add': { 	 
                                'products': [
                                    productDataToUse
                                ] 
                            } 
                        } 
                    });
                });
            });
    
            $('#yith-wacp-popup').on('click', e => {
                if ($(e.target).hasClass('go-cart')) {
                    if (!window.mm_visible_products_list || !window.mm_visible_products_list.length) {
                        return;
                    }
    
                    let variantValue = $('#yith-variable-products-variation-id').val();
                    let variantOption = $('#yith-variable-products-variation-id').find('option[value="' + variantValue + '"]');
                    let variantText = variantOption.text();
                    let productID = $(e.target).attr('onclick');
    
                    if (!!variantText && !!productID) {
                        variantText = variantText.split(';');
                        let productPrice = variantText[1];
                        variantText = variantText[0];
                        productID = productID.split('(');
    
                        if (productPrice) {
                            productPrice = productPrice.replace(',', '.');
                            productPrice = productPrice.replace(/[^0-9\.]/gmi, '');
                            productPrice = Number(parseFloat(productPrice)).toFixed(2);
                        }
    
                        if (productID.length > 1) {
                            productID = productID[1].replace(')', '');
                            productID = parseInt(productID, 10);
                            let productSKU = window.mm_visible_products_id_sku_map[productID];
                            let productData = window.mm_visible_products_list.filter(prod => prod.id === productSKU);
            
                            if (productData.length) {
                                let productDataToUse = productData[0];
                                productDataToUse.quantity = 1;
                                productDataToUse.variant = variantText;
                                productDataToUse.dimension9 = variantText;
                                productDataToUse.price = productPrice;
    
                                dataLayer.push({ 
                                    'event': 'addToCart', 
                                    'pageType': self.getPageType(),
                                    'languageVersion': 'PL', 
                                    'ecommerce': { 
                                        'currencyCode': 'PLN',
                                        'add': { 	 
                                            'products': [
                                                productDataToUse
                                            ] 
                                        } 
                                    } 
                                });
                            }
                        }
                    }
                }
            });
        }
    
        addToCartFromProduct () {
            let self = this;
    
            if (!$('body.single-product .single_add_to_cart_button').length) {
                return;
            }
    
            $('body.single-product .single_add_to_cart_button').each((i, btn) => {
                $(btn).on('click', function (e) {
                    if ($(btn).hasClass('disabled')) {
                        return false;
                    }
    
                    if ($(btn).attr('data-clicked') !== 'true') {
                        $(btn).attr('data-clicked', 'true');
    
                        let detectedVariant = false;
                        let detectedDimension9 = false;
    
                        if ($('.woovr-variation-selector').length) {
                            if ($('.woovr-variation-selector input[type="radio"]:checked').length) {
                                let labelName = $('.woovr-variation-selector input[type="radio"]:checked').eq(0).parent().parent().find('.woovr-variation-name');
                                
                                if (labelName.length) {
                                    detectedVariant = labelName.eq(0).text().replace(',', '.');
                                    detectedDimension9 = detectedVariant;
                                }
                            }
                        }
    
                        if (!detectedVariant) {
                            detectedVariant = window.mm_single_product_data.variant;
                        }
    
                        if (!detectedDimension9) {
                            detectedDimension9 = window.mm_single_product_data.dimension9;
                        }
    
                        dataLayer.push({ 
                            'event': 'addToCart', 
                            'pageType': self.getPageType(),
                            'languageVersion': 'PL', 
                            'ecommerce': { 
                                'currencyCode': 'PLN',
                                'add': { 	 
                                    'products': [{ 	 
                                        'name': window.mm_single_product_data.name,
                                        'id': window.mm_single_product_data.id,
                                        'price': window.mm_single_product_data.price,
                                        'brand': window.mm_single_product_data.brand,
                                        'category': window.mm_single_product_data.category,
                                        'quantity': parseInt($('.quantity input[name="quantity"]').eq(0).val(), 10),
                                        'variant': detectedVariant,
                                        'typ': window.mm_single_product_data.typ,
                                        'dimension9': detectedDimension9
                                    }] 
                                } 
                            }
                        });   
                    }
                });
            });
        }
    
        removeFromCart () {
            let self = this;
    
            if (!$('.woocommerce-cart .woocommerce-cart-form .product-remove').length) {
                return;
            }
    
            $('.woocommerce-cart .woocommerce').on('click', (e) => {
                if (!(e.target.tagName === 'A' && e.target.classList.contains('remove') && e.target.parentNode.classList.contains('product-remove'))) {
                    return;
                }
    
                let productPrice = '';
                let priceContent = $(e.target).parent().parent().find('.woocommerce-Price-amount');
                
                if (priceContent.length) {
                    productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                }
    
                let productName = '';
                let nameContent = $(e.target).parent().parent().find('.product-name > a');
    
                if (nameContent.length) {
                    productName = nameContent.text();
                }
    
                dataLayer.push({ 
                    'event': 'removeFromCart', 
                    'pageType': self.getPageType(),
                    'languageVersion': 'PL', 
                    'ecommerce': { 
                        'currencyCode': 'PLN',
                        'remove': { 	 
                            'products': [{ 	 
                                'name': productName,
                                'id': $(e.target).attr('data-product_sku'),
                                'price': productPrice,
                                'quantity': parseInt($(e.target).parent().parent().find('.quantity input').eq(0).val(), 10)
                            }] 
                        } 
                    }
                });  
                
                window.mm_items_in_cart = window.mm_items_in_cart.filter(prod => !(prod.name === productName && prod.id === $(e.target).attr('data-product_sku'))).slice();
            });
        }
    
        productLinks () {
            let self = this;
    
            if (!$('.woocommerce-LoopProduct-link').length) {
                return;
            }
    
            $('.woocommerce-LoopProduct-link').each((i, link) => {
                $(link).on('click', function (e) {
                    e.preventDefault();
    
                    let productCategory = '';
                    let categoryContent = $(this).find('.product-category');
    
                    if (categoryContent.length) {
                        productCategory = categoryContent.eq(0).text();
                    }
    
                    let productPrice = '';
                    let priceContent = $(this).find('.woocommerce-Price-amount');
                    
                    if (priceContent.length) {
                        productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                    }
    
                    let productName = '';
                    let nameContent = $(this).find('.woocommerce-loop-product__title');
    
                    if (nameContent.length) {
                        productName = nameContent.text();
                    }
    
                    let productID = $(this).parent().find('a[data-product_sku]').attr('data-product_sku');
                    let productDataToUse = { 	 
                        'name': productName,
                        'id': $(this).parent().find('a[data-product_sku]').attr('data-product_sku'),
                        'price': productPrice,
                        'category': productCategory
                    };
    
                    if (window.mm_visible_products_list) {
                        let productData = window.mm_visible_products_list.filter(prod => prod.id === productID);
    
                        if (productData.length) {
                            productDataToUse = productData[0];
                        }
                    }
    
                    dataLayer.push({ 
                        'event': 'productClick',  
                        'pageType': self.getPageType(),
                        'languageVersion': 'PL', 
                        'ecommerce': { 
                            'currencyCode': 'PLN',
                            'click': { 
                                'actionField': {
                                    'list': self.getListName()
                                },                          
                                'products': [
                                    productDataToUse
                                ] 
                            } 
                        },
                        'eventCallback': function () {
                            document.location = $(link).attr('href');
                        }
                    });
                });
            });
        }
    
        variableProductLinks () {
            let self = this;
    
            if (!$('.product_type_simple:not(.add_to_cart_button), .product_type_variable.add_to_cart_button').length) {
                return;
            }
    
            $('.product_type_simple:not(.add_to_cart_button), .product_type_variable.add_to_cart_button').each((i, link) => {
                $(link).on('click', function (e) {
                    e.preventDefault();
    
                    let productCategory = '';
                    let categoryContent = $(this).parent().find('.product-category');
    
                    if (categoryContent.length) {
                        productCategory = categoryContent.eq(0).text();
                    }
    
                    let productPrice = '';
                    let priceContent = $(this).parent().find('.woocommerce-Price-amount');
                    
                    if (priceContent.length) {
                        productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                    }
    
                    let productName = '';
                    let nameContent = $(this).parent().find('.woocommerce-loop-product__title');
    
                    if (nameContent.length) {
                        productName = nameContent.text();
                    }
    
                    let productID = $(this).attr('data-product_sku');
                    let productDataToUse = { 	 
                        'name': productName,
                        'id': $(this).attr('data-product_sku'),
                        'price': productPrice,
                        'category': productCategory,
                        'quantity': parseInt($(this).attr('data-quantity'), 10)
                    };
    
                    if (window.mm_visible_products_list) {
                        let productData = window.mm_visible_products_list.filter(prod => prod.id === productID);
    
                        if (productData.length) {
                            productDataToUse = productData[0];
                        }
                    }
    
                    dataLayer.push({ 
                        'event': 'productClick',
                        'pageType': self.getPageType(),
                        'languageVersion': 'PL', 
                        'ecommerce': { 
                            'currencyCode': 'PLN',
                            'click': { 
                                'actionField': {
                                    'list': self.getListName()
                                },	 
                                'products': [
                                    productDataToUse
                                ] 
                            } 
                        },
                        'eventCallback': function () {
                            document.location = $(link).attr('href');
                        }
                    });
                });
            });
        }
    
        getPageType () {
            let pageType = '';
    
            if ($('body').hasClass('search-results')) {
                pageType = 'search';
            } else if ($('body').hasClass('home')) {
                pageType = 'home';
            } else if ($('body').hasClass('single-product')) {
                pageType = 'product';
            } else if ($('body').hasClass('woocommerce-cart')) {
                pageType = 'basket';
            } else if ($('body').hasClass('archive')) {
                pageType = 'category';
            }
    
            return pageType;
        }
    
        getListName () {
            let listName = '';
    
            if ($('body').hasClass('search-results')) {
                listName = 'Wyniki wyszukiwania';
            } else if ($('body').hasClass('home')) {
                listName = 'Strona główna';
            } else if ($('body').hasClass('single-product')) {
                listName = 'Powiązane produkty';
            } else if ($('body').hasClass('woocommerce-cart')) {
                listName = 'Inni klienci kupili również';
            } else if ($('body').hasClass('archive')) {
                listName = 'Lista produktów w kategorii';
            }
    
            return listName;
        }
    
        updatedCartEvents () {
            let self = this;
    
            if (!$('.woocommerce-cart .woocommerce-cart-form button[name="update_cart"]').length) {
                return;
            }
    
            $(document.body).on('updated_wc_div', function() {
                let products = window.mm_items_in_cart.slice();
                let removedProducts = [];
                let cartForm = $('.woocommerce-cart-form');
    
                for (let i = 0; i < products.length; i++) {
                    let removeLink = cartForm.find('a.remove[data-product_sku="' + products[i].id + '"]');
                    
                    if (removeLink.length) {
                        let originalQuantity = products[i].quantity;
                        products[i].quantity = parseInt(removeLink.parents('.woocommerce-cart-form__cart-item').find('.qty').val(), 10);
                    } else {
                        removedProducts.push(JSON.parse(JSON.stringify(products[i])));
                    }
                }
    
                if (removedProducts.length) {
                    removedProducts = removedProducts.map(removedProduct => {
                        return {
                            'name': removedProduct.name,
                            'id': removedProduct.id,
                            'price': removedProduct.price,
                            'quantity': removedProduct.quantity
                        }
                    });
    
                    for (let i = 0; i < removedProducts.length; i++ ) {
                        products = products.filter(prod => !(prod.name === removedProducts[i].name && prod.id === removedProducts[i].id)).slice();
                    }
    
                    window.mm_items_in_cart = products.slice();
    
                    dataLayer.push({ 
                        'event': 'removeFromCart', 
                        'pageType': self.getPageType(),
                        'languageVersion': 'PL', 
                        'ecommerce': { 
                            'currencyCode': 'PLN',
                            'remove': { 	 
                                'products': removedProducts
                            } 
                        }
                    });
                }
    
                dataLayer.push({
                    'pageType': 'cart', 
                    'languageVersion': 'PL', 
                    'ecommerce': { 
                        'currencyCode': 'PLN', 
                        'checkout': { 
                            'actionField': { 
                                'step': 1, 
                                'option': 'cart', 
                                'action': 'checkout' 
                            }, 
                            'products': window.mm_items_in_cart.slice()
                        }
                    } 
                });
            });
        }
    }

    new MM_Menu();
    new MM_UI();  
    new MM_HeaderSlider();
    new MM_productListing();
    new MM_shopCheckout();
    new MM_GTMEvents();
})(jQuery);